@if ((isInitialLoad && isLoading) && shimmerTemplate) {
  <div class="shimmer">
    <ng-container *ngTemplateOutlet="shimmerTemplate" />
  </div>
  }

  @if (!isLoading && emptyListTemplate && items?.length === 0) {
  <ng-container *ngTemplateOutlet="emptyListTemplate" />
  }

  @if (items?.length > 0) {
  <cdk-virtual-scroll-viewport [itemSize]="isVirtualScrollActive ? itemSize : null"
    (loadMore)="onLoadMore($event)">
    <div *cdkVirtualFor="let item of items; let index = index; let count = count; let first = first; let last = last; let even = even; let odd = odd;">

      @if (itemTemplate) {
      <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item, index, first, last, even, odd, $index: index }" />
      } @else { item render template is not implemented, Index: {{ index }} }

      @if (hasMore && isLoading && loadingMoreTemplate && last) {
      <ng-container *ngTemplateOutlet="loadingMoreTemplate" />
      }
    </div>
  </cdk-virtual-scroll-viewport>
  }
